export default __webpack_public_path__ + "static/media/family-picture-placeholder-mobile.ed48f27a.svg";